const applicantDetailsDictionary = {
  verifyPan: () => "api/v1/applicant/verify-pan",
  aadhaarApplication: () => "api/v1/applicant/create-app-via-aadhaar-phone",
  digilockerApplication: () => "api/v1/applicant/verify-aadhaar",
  verifyAadhaarApplication: () => `api/v1/applicant/eaadhaar-details`,
  createApplicant: () => "api/v1/applicant/create",
  applicantIssueFile: (trackingId: string) => `api/v1/applicant/issued-files-list/${trackingId}`,

};
export default applicantDetailsDictionary;
